import React from 'react';
import moment from 'moment';
import {Card} from '../Card';
import {Text} from '../Text';
import {Button} from '../Button';


export function CampaignCard(props) {
  return (
    <Card style={{padding:0, marginBottom:16, display:'flex', flexDirection:'row', alignItems:'stretch', ...props.style}}>
      <Button tertiary to={props.to || `/campaigns/${props.id}`} style={{display:'block', flex:1, padding:16}}>
        <Text block semibold color="#00b2a8" style={{marginBottom:4}}>{props.name}</Text>
        <Text block small style={{marginBottom:12}}>
          {moment(props.start).format("MMMM DD")} - {moment(props.end).format("MMMM DD")}
        </Text>
        <div 
          style={{
            display: 'inline-block',
            padding: "0px 8px 4px 8px",
            backgroundColor: props.datePublished ? "#00b2a8" : "#e3e5e4",
            borderRadius: 12,
          }}>
          <Text 
            semibold
            style={{
              fontSize:10, 
              color: props.datePublished ? "#ffffff" : "#243746",
            }}>
            {props.datePublished ? "ACTIVE" : "DRAFT"}
          </Text>
        </div>
      </Button>
      <div 
        style={{
          width: 80,
          height: 100,
          margin: 8,
          backgroundImage: props.preview ? `url(${props.preview})` : 'none',
          backgroundPosition: 'center right',
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
        }}
      />
    </Card>
  );  
}